// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IngestionSpecListItem } from './ingestion-spec-list-item';
import {
    IngestionSpecListItemFromJSON,
    IngestionSpecListItemFromJSONTyped,
    IngestionSpecListItemToJSON,
    IngestionSpecListItemToJSONTyped,
} from './ingestion-spec-list-item';

/**
 * 
 * @export
 * @interface ListIngestionSpecsResponseContent
 */
export interface ListIngestionSpecsResponseContent {
    /**
     * 
     * @type {Array<IngestionSpecListItem>}
     * @memberof ListIngestionSpecsResponseContent
     */
    ingestionSpecs: Array<IngestionSpecListItem>;
    /**
     * 
     * @type {string}
     * @memberof ListIngestionSpecsResponseContent
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the ListIngestionSpecsResponseContent interface.
 */
export function instanceOfListIngestionSpecsResponseContent(value: object): value is ListIngestionSpecsResponseContent {
    if (!('ingestionSpecs' in value) || value['ingestionSpecs'] === undefined) return false;
    return true;
}

export function ListIngestionSpecsResponseContentFromJSON(json: any): ListIngestionSpecsResponseContent {
    return ListIngestionSpecsResponseContentFromJSONTyped(json, false);
}

export function ListIngestionSpecsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIngestionSpecsResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'ingestionSpecs': ((json['ingestionSpecs'] as Array<any>).map(IngestionSpecListItemFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function ListIngestionSpecsResponseContentToJSON(json: any): ListIngestionSpecsResponseContent {
    return ListIngestionSpecsResponseContentToJSONTyped(json, false);
}

export function ListIngestionSpecsResponseContentToJSONTyped(value?: ListIngestionSpecsResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ingestionSpecs': ((value['ingestionSpecs'] as Array<any>).map(IngestionSpecListItemToJSON)),
        'nextToken': value['nextToken'],
    };
}
